import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {QuestionType} from '../../constants';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {GlobalQuestionService} from '../../services/global-question.service';
import { ComponentsService } from '../../services/components-service';

@Component({
    selector: 'app-question-controller',
    templateUrl: './question-controller.component.html',
    styleUrls: ['./question-controller.component.scss'],
    standalone: false
})
export class QuestionControllerComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() childItemQuestions: Question[] = [];
  @Input() funeralMemberQuestions: any[] = [];
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() showLabelQuestionCopy = false;
  @Input() showLabelEmailVersion = false;
  @Input() showUploaderNoteText = false;
  @Input() showUploaderLabelText = false;
  @Input() uploaderLabelText = '';
  @Input() uploaderNoteText = '';
  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() vap: QuotePageDataVaps;
  @Input() product_id: any;
  @Input() isEditModal = false;
  @Input() addAnother = false;
  @Input() addAddons = false;
  @Input() showParent = false;
  @Input() damageModalNarrow = false;
  @Input() showSkip = false;
  @Input() controlCssClass = '';
  @Input() useUiFront = true;
  @Input() evi = false;
  @Output() amountChanged = new EventEmitter<number>();
  @Output() questionAnswer = new EventEmitter();
  @Output() questionHasError = new EventEmitter<boolean>();
  @Output() selectedOption = new EventEmitter();

  tempQuestion: Question;
  QuestionType = QuestionType;
  session_details: any;

  constructor(private questionFlowSessionQuery: QuestionFlowSessionQuery,
    public globalQuestionService: GlobalQuestionService) {
    this.session_details = this.questionFlowSessionQuery.getValue();
  }

  ngOnInit(): void {
 
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.tempQuestion = JSON.parse(JSON.stringify(this.question));
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.damageModalNarrow?.currentValue !== changes?.damageModalNarrow?.previousValue) {
      this.damageModalNarrow = changes?.damageModalNarrow?.currentValue;
    }
    if (changes?.showSkip?.currentValue !== changes?.showSkip?.previousValue) {
      this.showSkip = changes?.showSkip?.currentValue;
    }
  }

  questionAnswerController(event): void {

    if (this.isEditModal) {
      if (this.tempQuestion?.answer !== this.question?.answer) {
        this.questionAnswer.emit(event);
        if (this.session_details?.session_id !== '' || event?.session_id) {
          this.globalQuestionService.saveIndividualAnswer(event, event.item_id)
            .subscribe(() => {
            })
        }
       
      }
    } else {
      
      this.questionAnswer.emit(event);
    }
  }

  setAddAnother(value: boolean): void {
    this.addAnother = value;
  }

  setAddAddon(value: boolean): void {
    this.addAddons = value;
  }
  
}
